module.exports = __webpack_public_path__ + "static/img/banner.75539171.jpg";